// src/utils/firebaseConfig.js

const firebaseConfig = {
  apiKey: "AIzaSyBgQbcDaQxkd57-RGtsgAuH1vg8Jj6S3HY",
  authDomain: "efilmhub-72665.firebaseapp.com",
  databaseURL: "https://efilmhub-72665-default-rtdb.firebaseio.com",
  projectId: "efilmhub-72665",
  storageBucket: "efilmhub-72665.appspot.com",
  messagingSenderId: "973885895788",
  appId: "1:973885895788:web:8c7c5d9dc5d9d047b71449",
};

export default firebaseConfig;
